import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'gdp-confirm-activate-did-popup',
  templateUrl: './confirm-activate-did-popup.component.html',
  styleUrls: ['./confirm-activate-did-popup.component.scss']
})
export class ConfirmActivateDidPopupComponent implements OnInit {
  public form: UntypedFormGroup;
  @Input() hasTemporaryNumber: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private modal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      isProviderApprovedVD: new UntypedFormControl(false, Validators.requiredTrue),
      isNumberActiveAtProvider: new UntypedFormControl(false, Validators.requiredTrue),
      isCallTested: new UntypedFormControl(false, Validators.requiredTrue)
    });
    if (this.hasTemporaryNumber) {
      this.form.addControl('isConfirmTmpNumberRemove', new UntypedFormControl(false, Validators.requiredTrue))
    }
  }

  ok() {
    this.modal.close('ok');
  }

  cancel() {
    this.modal.close('cancel');
  }

  close() {
    this.modal.close('close');
  }

}
